import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { IconsDirective } from './icons.directive';
import { IIconDefinition } from './icons.interfaces';
import { DP_ICONS, IconsService } from './icons.service';

@NgModule({
  imports: [CommonModule],
    declarations: [IconsDirective, ],
    exports: [IconsDirective],
})
export class IconsModule {
  static forChild(icons: IIconDefinition[]): ModuleWithProviders<IconsModule> {
    return {
      ngModule: IconsModule,
      providers: [
        IconsService,
        {
          provide: DP_ICONS,
          useValue: icons,
        },
      ],
    };
  }
}
